import styled from 'styled-components'
import { getAddress } from 'viem'
import { Avatar as AvatarT } from './api'

export const GLOW = 'rgba(127, 212, 232, 0.55)'

export const short = (a: string) => {
  try {
    const c = getAddress(a)
    return `${c.slice(0, 6)}…${c.slice(-4)}`
  } catch {
    return a
  }
}

const Ring = styled.span<{ $size: number; $muted?: boolean; $lvl?: number | null }>`
  position: relative;
  flex: none;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  overflow: hidden;
  display: inline-grid;
  place-items: center;
  background: rgba(255, 255, 255, 0.06);
  color: ${({ theme }) => theme.colors.textSubtle};
  box-shadow: ${({ $muted, $lvl }) => ($muted ? 'none' : $lvl === 2 ? '0 0 0 3px #b38bff, 0 0 26px rgba(179, 139, 255, 0.55)' : `0 0 0 3px ${GLOW}, 0 0 22px rgba(127, 212, 232, 0.35)`)};
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`
export function AvatarImg({ avatar, size = 40, off }: { avatar?: AvatarT | null; size?: number; off?: boolean }) {
  return (
    <Ring $size={size} $muted={off || !avatar} $lvl={avatar?.level} aria-hidden>
      {avatar?.image && !off ? (
        <img src={avatar.image} alt="" loading="lazy" />
      ) : (
        <svg viewBox="0 0 24 24" width={size * 0.5} height={size * 0.5} fill="currentColor">
          <circle cx="12" cy="8.5" r="4" />
          <path d="M4 20c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5z" />
        </svg>
      )}
    </Ring>
  )
}

